

















































/* Created- 27 - Nov - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ScheduledLiveTaskDTO } from "../../Generated/ParticaAPI";
import { ValidDate, parseIso, format, addDate } from "ts-date/esm/locale/en";
@Component(
	{
		name: "ScheduledTask"
	})
export default class ScheduledTask extends Vue {
	@Prop() private task: ScheduledLiveTaskDTO;
	private active: boolean = false;
	private dates: Date[] = [];
	@Watch("active")
	private watcher() {
		if (this.active === true) {
			this.task.status = 1;
		} else {
			this.task.status = 0;
		}
	}
	private getLocalDate(): Date {
		return new Date();
	}
	private getGMTDate(): string {
		return new Date().toUTCString();
	}
	private getNiceDate(d: ValidDate) {
		return format(d, "YYYY-MM-DD");
	}
	private getLocalLive(d: ValidDate) {
		const dateStr: string = this.getNiceDate(d) + "T" + this.task.time + "Z";
		if (dateStr !== null) {
			// @ts-ignore
			return parseIso(dateStr).toLocaleString();
		} else {
			return "Unknown";
		}
	}

	private mounted() {
		const today = new Date() as ValidDate;
		for (let i = 0; i < 7; i++) {
			this.dates.push(addDate(today, i));
		}
		this.active = this.task.status === 1 ? true : false;
	}
}
